import { BiddingIntradayMarketAreaGroup } from '@ebalance/proto/bffuser/v1/bidding_intraday_market_model_pb'
import type { TFunction } from 'i18next'

/**
 * エリアグループの表示ラベル。 板の列見出しと約定ティッカーの推定エリア (AC-BIN-031 「§4 の
 * 板情報と同じ表記」) で同じ表記を使う。 単一エリアの組 (HOKKAIDO / KYUSHU) は canonical な
 * `common:area.*` と同じ文言のため、 module-level Record ではなく `t` を受ける resolver
 * 関数にしている (= `SpotBidTable` の `issuerLicenseLabel` と同じ流儀)。
 */
export const areaGroupLabel = (
  t: TFunction,
  ag: BiddingIntradayMarketAreaGroup,
): string => {
  switch (ag) {
    case BiddingIntradayMarketAreaGroup.HOKKAIDO:
      return t('common:area.hokkaido')
    case BiddingIntradayMarketAreaGroup.TOHOKU_TOKYO:
      return t('page:biddingIntraday.market.board.areaGroup.tohokuTokyo')
    case BiddingIntradayMarketAreaGroup.CHUBU_HOKURIKU_KANSAI:
      return t(
        'page:biddingIntraday.market.board.areaGroup.chubuHokurikuKansai',
      )
    case BiddingIntradayMarketAreaGroup.CHUGOKU_SHIKOKU:
      return t('page:biddingIntraday.market.board.areaGroup.chugokuShikoku')
    case BiddingIntradayMarketAreaGroup.KYUSHU:
      return t('common:area.kyushu')
    default:
      return ''
  }
}
